/**
 * Maintenance Mode Configuration
 * 
 * Set MAINTENANCE_MODE to true to enable maintenance page
 * Set MAINTENANCE_MODE to false to disable maintenance page
 */

export const MAINTENANCE_MODE = false;

/**
 * Paths that should be accessible even during maintenance mode
 * (e.g., admin routes)
 */
export const MAINTENANCE_WHITELIST = [
  '/mgt-x7k9p2/auth',
  '/mgt-x7k9p2/dashboard',
  '/mgt-x7k9p2/send-discount-codes',
];
